Nis = $.extend(Nis, {
  Login: function(options) {
    var service = function() {
      var self = this;

      this.events = {
        REQUEST_COMPLETE: 'request_complete'
      };

      this.operations = {
        SEND_RECOVERY_EMAIL: 'send_recovery_email',
        GET_PASSWORD_POLICY: 'get_password_policy',
        CHANGE_PASSWORD: 'change_password'
      };

      this.sendRecoveryEmail = function(organisation, username, email, callback) {
        invoke(self.operations.SEND_RECOVERY_EMAIL, { 'organisationcode': organisation, 'username': username, 'email': email }, false, callback);
      };

      this.getPasswordPolicy = function(organisation, username, guid, callback) {
        invoke(self.operations.GET_PASSWORD_POLICY, { 'organisationcode': organisation, 'username': username, 'changepasswordguid': guid }, false, callback);
      };

      this.changePassword = function(organisation, username, guid, newPassword, confirmPassword, callback) {
        invoke(self.operations.CHANGE_PASSWORD, { 'organisationcode': organisation, 'username': username, 'changepasswordguid': guid, 'newpassword': newPassword, 'confirmpassword': confirmPassword }, false, callback);
      };

      var invoke = function(operation, parameters, sync, callback) {
        var url = Nis.RootPath + 'inc/handlers/user/UserCredentials.ashx';
        var para = { 'operation': operation, 'request': JSON.stringify(parameters) };

        $.ajax({
          url: url,
          type: 'post',
          async: !sync,
          data: para,
          cache: false,
          dataType: 'json',
          success: function(json) {
            $(self).trigger(self.events.REQUEST_COMPLETE, json);
            if (callback != null && typeof (callback) == 'function')
              callback(json);
          },
          error: function(xhr) {
            throw xhr.statusText;
          }
        });
      };
    };

    var svc = new service();
    var tmpl = Nis.Gui.tmpl;
    var modal = Nis.Gui.Modal;
    var cnt = null;
    var dialog;

    var templates = {
      'DIALOG': '<div class="dialog form user-credentials"><div class="titlebar">{lbl_header}<div class="x-close closeDialog"></div></div><div class="content"><table><tr><td class="label">{lbl_organisation}</td></tr><tr><td><div class="input_wrap"><input type="text" class="input user-credentials-organisation" value="{organisation}" /></div></td></tr><tr><td class="label">{lbl_username}</td></tr><tr><td><div class="input_wrap"><input type="text" class="input user-credentials-username" value="{username}" /></div></td></tr><tr><td class="split">{lbl_splitword}</td></tr><tr><td class="label">{lbl_email}</td></tr><tr><td><div class="input_wrap"><input type="text" class="input user-credentials-email" value="" /></div></td></tr><tr><td class="user-credentials-buttons"><input type="button" value="{lbl_send}" class="user-credentials-send" /></td></tr></table></div></div>',
      'CHANGE_PASSWORD_DIALOG': '<div class="dialog form user-change-password"><div class="titlebar">{lbl_header}<div class="x-close closeDialog"></div></div><div class="content"><table><tr><td class="label">{lbl_new_password}</td></tr><tr><td><div class="input_wrap"><input type="password" class="input user-change-password-new" /></div></td></tr><tr><td class="label">{lbl_confirm_new_password}</td></tr><tr><td><div class="input_wrap"><input type="password" class="input user-change-password-confirm" /></div></td></tr><tr>{policy_container}<td class="user-change-password-buttons"><input type="button" value="{lbl_save}" class="user-change-password-save" /></td></tr></table></div></div>',
      'PASSWORD_POLICY': '<tr><td><div class="user-change-password-policy"><b>{header}</b><ul>{policy}</ul></div></td></tr>'
    };

    this.init = function(container) {
      cnt = container;

      cnt.on('click', '.recovery', function() {
        var organisation = $('#txtAgent').val();
        var username = $('#txtUsername').val();

        openDialog(organisation, username);
        return false;
      });

            if (options.username && options.organisation && options.guid) {
                svc.getPasswordPolicy(options.organisation, options.username, options.guid, function (response) {
                    if (response.Success) {
                        openChangePasswordDialog(response);
                    } else {
                        alert(response.Errors);
                    }

          return false;
        });
      }
    };

    var openDialog = function(organisation, username) {
      dialog = $(tmpl(templates.DIALOG, {
        'lbl_header': Nis.Translations.forgotYourPassword,
        'lbl_organisation': Nis.Translations.organization,
        'lbl_username': Nis.Translations.username,
        'lbl_splitword': Nis.Translations.or,
        'lbl_email': Nis.Translations.email,
        'lbl_send': Nis.Translations.send,
        'organisation': organisation,
        'username': username
      }));

      modal.make(dialog, true);
      modal.show(dialog);

      dialog.on(modal.events.CLOSED, function() {
        dialog.remove();
        dialog = null;
      });

      dialog.on('click', '.user-credentials-send', function() {
        var org = dialog.find('.user-credentials-organisation').val();
        var user = dialog.find('.user-credentials-username').val();
        var email = dialog.find('.user-credentials-email').val();

        svc.sendRecoveryEmail(org, user, email, function(response) {
          if (response.Success) {
            modal.hide(dialog);
            alert(Nis.Translations.credentialsSentByEmail);
          } else {
            alert(response.Errors);
          }
        });
      });
    };

    var openChangePasswordDialog = function(data) {
      var policy = '';

      $.each(data.PasswordPolicy, function(index, item) {
        policy += '<li>' + item + '</li>';
      });

      dialog = $(tmpl(templates.CHANGE_PASSWORD_DIALOG, {
        'lbl_header': Nis.Translations.changePassword,
        'lbl_new_password': Nis.Translations.newPassword,
        'lbl_confirm_new_password': Nis.Translations.confirmNewPassword,
        'policy_container': policy != '' ? Nis.Gui.tmpl(templates.PASSWORD_POLICY, { 'header': Nis.Translations.passwordPolicy, 'policy': policy }) : policy,
        'lbl_save': Nis.Translations.save
      }));

      modal.make(dialog, true);
      modal.show(dialog);

      dialog.on(modal.events.CLOSED, function() {
        dialog.remove();
        dialog = null;
      });

      dialog.on('click', '.user-change-password-save', function() {
        var newPassword = dialog.find('.user-change-password-new').val();
        var confirmPassword = dialog.find('.user-change-password-confirm').val();

        svc.changePassword(options.organisation, options.username, options.guid, newPassword, confirmPassword, function(response) {
          if (response.Success) {
            modal.hide(dialog);
            alert(Nis.Translations.passwordChanged);
            location.href = Nis.RootPath + 'user/login.aspx';
          } else {
            alert(response.Errors);
          }
        });
      });
    };
  }
});



// WEBPACK FOOTER //
// ./../inc/javascripts/Nis.Login.js